import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Box, Tabs, Tab, useTheme, useMediaQuery, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, IconButton, AppBar, Toolbar, Typography, Switch, ListItemIcon, ListItemText, TextField, Drawer, List, ListItem, ListItemButton, Divider, Tooltip } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import BarChartIcon from '@mui/icons-material/BarChart';
import SettingsIcon from '@mui/icons-material/Settings';
import FlagIcon from '@mui/icons-material/Flag';
import GroupIcon from '@mui/icons-material/Group';
import HelpIcon from '@mui/icons-material/Help';
import ListAltIcon from '@mui/icons-material/ListAlt';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import NotesIcon from '@mui/icons-material/Notes';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import YearTabs from './YearTabs';
import Statistics from './Statistics';
import HabitManagement from './HabitManagement';
import Goals from './Goals';
import UserManagement from './UserManagement';
import Help from './Help';
import Settings from './Settings';
import { getContrastText } from '../utils/colorUtils';
import { alpha } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useDrawer } from '../contexts/DrawerContext';
import { useArea } from '../contexts/AreaContext';
import { doc, getDoc, updateDoc, onSnapshot, arrayRemove, arrayUnion } from 'firebase/firestore';
import { db, isUserAdmin } from '../services/firebase';
import MonthCalendar from './MonthCalendar';
import Challenges from './Challenges';
import Notes from './Notes';
import Events from './Events';
import MenuComponent from './Menu';
import CentralDashboard from './CentralDashboard';
import PillarDashboard from './PillarDashboard';
import ProsperityBudget from './prosperity/ProsperityBudget';
import ProsperityInvestments from './prosperity/ProsperityInvestments';
import ProsperitySimulator from './prosperity/ProsperitySimulator';
import { useNavigate, Navigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import Pomodoro from './Pomodoro';
import Player from './Player';
import LogoutIcon from '@mui/icons-material/Logout';
import Calendar from './Calendar';
import PageLayout from './PageLayout';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import Meditations from './Meditations';
import Sleep from './Sleep';
import Treinos from './Treinos';
import Estudos from './Estudos';
import Nutricao from './Nutricao';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import HomeIcon from '@mui/icons-material/Home';
import SpaIcon from '@mui/icons-material/Spa';
import { Link } from 'react-router-dom';
import { usePlayer } from '../contexts/PlayerContext';
import TimerIcon from '@mui/icons-material/Timer';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import EventIcon from '@mui/icons-material/Event';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import NoteIcon from '@mui/icons-material/Note';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import BedtimeIcon from '@mui/icons-material/Bedtime';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import SchoolIcon from '@mui/icons-material/School';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import CalculateIcon from '@mui/icons-material/Calculate';
import BookRecommendations from './BookRecommendations';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import ptBR from 'date-fns/locale/pt-BR';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const isModuleEnabled = (moduleId) => {
  // Sempre habilita Menu, Settings e Help
  if (moduleId === 'menu' || moduleId === 'settings' || moduleId === 'help') {
    return true;
  }
  // Oculta o módulo de calendário, pois a visão de checkboxes está na Central
  if (moduleId === 'calendar') {
    return false;
  }
  return true;
};

const menuItems = [
  { id: 'menu', label: 'Início', icon: <HomeIcon /> },
  { id: 'calendar', label: 'Calendário', icon: <CalendarMonthIcon /> },
  { id: 'habits', label: 'Hábitos', icon: <CheckCircleIcon /> },
  { id: 'goals', label: 'Metas', icon: <FlagIcon /> },
  { id: 'challenges', label: 'Desafios', icon: <EmojiEventsIcon /> },
  { id: 'pomodoro', label: 'Pomodoro', icon: <TimerIcon /> },
  { id: 'player', label: 'Player', icon: <PlayArrowIcon /> },
  { id: 'notes', label: 'Anotações', icon: <NoteIcon /> },
  { id: 'events', label: 'Eventos', icon: <EventIcon /> },
  { id: 'statistics', label: 'Estatísticas', icon: <BarChartIcon /> },
  { id: 'livros', label: 'Dicas de Livros', icon: <MenuBookIcon /> },
  { id: 'meditations', label: 'Meditações', icon: <SelfImprovementIcon /> },
  { id: 'sleep', label: 'Sono', icon: <BedtimeIcon /> },
  { id: 'treinos', label: 'Treinos', icon: <FitnessCenterIcon /> },
  { id: 'estudos', label: 'Estudos', icon: <SchoolIcon /> },
  { id: 'nutricao', label: 'Nutrição', icon: <RestaurantIcon /> },
  { id: 'orcamento', label: 'Orçamento Pessoal', icon: <AccountBalanceWalletIcon /> },
  { id: 'investimentos', label: 'Investimentos', icon: <TrendingUpIcon /> },
  { id: 'simulador', label: 'Simulador', icon: <CalculateIcon /> },
  { id: 'settings', label: 'Configurações', icon: <SettingsIcon /> },
  { id: 'help', label: 'Ajuda', icon: <HelpIcon /> }
];

// Estrutura do menu lateral: MENU > CENTRAL | VITALIDADE | MENTALIDADE | PROSPERIDADE (3 pilares)
const MENU_SECTIONS = [
  {
    id: 'central',
    label: 'Central',
    icon: <HomeIcon />,
    color: '#9e9e9e',
    items: [
      { id: 'habits', label: 'Hábitos' },
      { id: 'goals', label: 'Metas' },
      { id: 'challenges', label: 'Desafios' },
      { id: 'notes', label: 'Anotações' },
      { id: 'events', label: 'Eventos' },
      { id: 'statistics', label: 'Estatísticas' },
    ],
  },
  {
    id: 'vitalidade',
    label: 'Vitalidade',
    icon: <SpaIcon />,
    color: '#2E7D32',
    items: [
      { id: 'sleep', label: 'Sono' },
      { id: 'treinos', label: 'Treinos' },
      { id: 'nutricao', label: 'Nutrição' },
    ],
  },
  {
    id: 'mentalidade',
    label: 'Mentalidade',
    icon: <EmojiEventsIcon />,
    color: '#F9A825',
    items: [
      { id: 'meditations', label: 'Meditações' },
      { id: 'livros', label: 'Dicas de Livros' },
      { id: 'estudos', label: 'Estudos' },
    ],
  },
  {
    id: 'prosperidade',
    label: 'Prosperidade',
    icon: <BarChartIcon />,
    color: '#E65100',
    items: [
      { id: 'orcamento', label: 'Orçamento Pessoal' },
      { id: 'investimentos', label: 'Investimentos' },
      { id: 'simulador', label: 'Simulador' },
    ],
  },
];

const availableModules = menuItems.filter(item => {
  if (item.id === 'menu' || item.id === 'settings' || item.id === 'help') return true;
  return isModuleEnabled(item.id);
});

function Navigation({ 
  habits, 
  onAddHabit, 
  onDeleteHabit,
  onDeleteAllHabits,
  onUpdateHabit,
  onToggleHabit,
  onReorderHabits,
  customColors,
  onUpdateCustomColors,
  showDailyQuote,
  onToggleDailyQuote,
  userId,
  mode,
  onToggleMode,
  currentTab,
  setCurrentTab,
  children
}) {
  const [value, setValue] = useState(0);
  const [calendarComponentsOrder, setCalendarComponentsOrder] = useState(['calendar', 'progress', 'donuts', 'area', 'stats']);
  const [isAdmin, setIsAdmin] = useState(false);
  const [enabledModules, setEnabledModules] = useState({});
  const [preferences, setPreferences] = useState(null);
  const [goals, setGoals] = useState([]);
  const [challenges, setChallenges] = useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { currentUser, logout } = useAuth();
  const { handleStop } = usePlayer();
  const { drawerOpen, setDrawerOpen, drawerWidth } = useDrawer();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [habitToDelete, setHabitToDelete] = useState(null);
  const [showDeleteAllDialog, setShowDeleteAllDialog] = useState(false);
  const [showDeleteAllGoalsDialog, setShowDeleteAllGoalsDialog] = useState(false);
  const [showDeleteAllChallengesDialog, setShowDeleteAllChallengesDialog] = useState(false);
  const [showDeleteAllNotesDialog, setShowDeleteAllNotesDialog] = useState(false);
  const navigate = useNavigate();
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const habitManagementRef = useRef();
  const [editEventDialog, setEditEventDialog] = useState({ open: false, event: null });
  const [editEventForm, setEditEventForm] = useState(null);
  const [editEventError, setEditEventError] = useState('');
  const [events, setEvents] = useState([]);
  const [successSnackbar, setSuccessSnackbar] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const { activeArea, setActiveArea } = useArea();

  const checkModuleEnabled = useCallback((moduleName) => {
    return true; // Todos os módulos estão habilitados
  }, []);

  const handleMonthChange = (month) => {
    setSelectedMonth(month);
  };

  const handleYearChange = (year) => {
    setSelectedYear(year);
  };

  const handleLogout = async () => {
    try {
      // Para o áudio antes de fazer logout
      handleStop();
      
      await logout();
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
    }
  };

  const handleTabChange = (newTab) => {
    // Garante que não há transição ao mudar de seção
    setIsTransitioning(false);
    // Não altera o estado do drawer ao mudar de aba - apenas navega
    setCurrentTab(newTab);
    navigate(`/${newTab === 'menu' ? '' : newTab}`);
  };

  useEffect(() => {
    const loadComponentsOrder = async () => {
      if (userId) {
        const userRef = doc(db, 'users', userId);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const userData = userSnap.data();
          if (userData.preferences?.calendarComponentsOrder) {
            setCalendarComponentsOrder(userData.preferences.calendarComponentsOrder);
          }
        }
      }
    };
    loadComponentsOrder();
  }, [userId]);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (userId) {
        try {
          const userRef = doc(db, 'users', userId);
          const userSnap = await getDoc(userRef);
          
          if (userSnap.exists()) {
            const userData = userSnap.data();
          } else {
            console.error('Documento do usuário não encontrado no Navigation');
          }
          
          const adminStatus = await isUserAdmin(userId);
          setIsAdmin(adminStatus);
        } catch (error) {
          console.error('Erro ao verificar status de admin:', error);
          setIsAdmin(false);
        }
      }
    };
    
    checkAdminStatus();
  }, [userId]);

  useEffect(() => {
    const loadUserModules = async () => {
      if (userId) {
        try {
          const userRef = doc(db, 'users', userId);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            const userData = userSnap.data();
            setEnabledModules(userData.enabledModules || availableModules.map(m => m.id));
          }
        } catch (error) {
          console.error('Erro ao carregar módulos:', error);
        }
      }
    };
    loadUserModules();
  }, [userId]);

  useEffect(() => {
    if (!userId) return;

    // Carregar metas
    const unsubscribeGoals = onSnapshot(doc(db, 'users', userId), (doc) => {
      if (doc.exists()) {
        const userData = doc.data();
        setGoals(userData.goals || []);
      }
    });

    // Carregar desafios
    const unsubscribeChallenges = onSnapshot(doc(db, 'users', userId), (doc) => {
      if (doc.exists()) {
        const userData = doc.data();
        setChallenges(userData.challenges || []);
      }
    });

    return () => {
      unsubscribeGoals();
      unsubscribeChallenges();
    };
  }, [userId]);

  useEffect(() => {
    const loadUserPreferences = async () => {
      if (userId) {
        try {
          const userRef = doc(db, 'users', userId);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            const userData = userSnap.data();
            setPreferences(userData.preferences || {});
          }
        } catch (error) {
          console.error('Erro ao carregar preferências:', error);
        }
      }
    };
    loadUserPreferences();
  }, [userId]);

  useEffect(() => {
    if (preferences) {
      setEnabledModules({
        habits: true, // Módulo principal sempre habilitado
        calendar: true,
        events: preferences.enableEvents ?? true,
        quotes: preferences.enableQuotes ?? true,
        statistics: preferences.enableStatistics ?? true,
        pomodoro: true,
        player: true,
        goals: true,
        challenges: true,
        notes: true,
        meditations: true,
        menu: true,
        settings: true,
        help: true
      });
    } else {
      // Define todos os módulos como habilitados por padrão
      setEnabledModules({
        habits: true,
        calendar: true,
        events: true,
        quotes: true,
        statistics: true,
        pomodoro: true,
        player: true,
        goals: true,
        challenges: true,
        notes: true,
        meditations: true,
        menu: true,
        settings: true,
        help: true
      });
    }
  }, [preferences]);

  useEffect(() => {
    if (editEventDialog.open && editEventDialog.event) {
      setEditEventForm({ ...editEventDialog.event });
      setEditEventError('');
    }
  }, [editEventDialog]);

  const loadEvents = async () => {
    if (!currentUser?.uid) return;
    try {
      const userRef = doc(db, 'users', currentUser.uid);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        const userData = userSnap.data();
        const loadedEvents = (userData.events || []).map(event => ({
          ...event,
          date: event.date ? new Date(event.date) : null,
          time: event.time ? new Date(event.time) : null
        }));
        setEvents(loadedEvents);
      }
    } catch (error) {
      // Silenciar erro
    }
  };

  useEffect(() => { loadEvents(); }, [currentUser]);

  // Mantém o drawer sincronizado com mudanças de tamanho de tela
  useEffect(() => {
    const wasManuallyClosed = sessionStorage.getItem('drawerManuallyClosed') === 'true';
    if (!isMobile && !drawerOpen && !wasManuallyClosed) {
      setDrawerOpen(true);
      setIsTransitioning(false);
    } else if (isMobile && drawerOpen) {
      setDrawerOpen(false);
      setIsTransitioning(false);
    }
  }, [isMobile]);

  const handleEditEventSave = async () => {
    if (!editEventForm.title?.trim()) {
      setEditEventError('O título do evento é obrigatório');
      return;
    }
    if (!editEventForm.date) {
      setEditEventError('A data é obrigatória');
      return;
    }
    if (!currentUser?.uid) {
      setEditEventError('Usuário não autenticado');
      return;
    }
    try {
      const userRef = doc(db, 'users', currentUser.uid);
      const userDoc = await getDoc(userRef);
      const userData = userDoc.data();
      const events = userData.events || [];
      const eventIndex = events.findIndex(e => e.id === editEventForm.id);
      if (eventIndex !== -1) {
        const updatedEvent = {
          ...events[eventIndex],
          title: editEventForm.title,
          description: editEventForm.description,
          date: editEventForm.date instanceof Date && !isNaN(editEventForm.date)
            ? editEventForm.date.toISOString()
            : (typeof editEventForm.date === 'string' ? editEventForm.date : null),
          time: editEventForm.time instanceof Date && !isNaN(editEventForm.time)
            ? editEventForm.time.toISOString()
            : (typeof editEventForm.time === 'string' ? editEventForm.time : null),
          completed: events[eventIndex].completed,
          completedAt: events[eventIndex].completedAt
        };
        await updateDoc(userRef, {
          events: arrayRemove(events[eventIndex])
        });
        await updateDoc(userRef, {
          events: arrayUnion(updatedEvent)
        });
      }
      await loadEvents();
      setEditEventDialog({ open: false, event: null });
      setSuccessSnackbar(true);
    } catch (error) {
      setEditEventError('Erro ao salvar evento. Tente novamente.');
    }
  };

  // Funções auxiliares - usando useCallback para estabilidade
  const handleOpenDialog = React.useCallback(() => {
    if (currentTab === 'goals') {
      Goals.onAdd();
    } else if (currentTab === 'notes') {
      Notes.onAdd();
    }
  }, [currentTab]);

  const handleOpen = React.useCallback(() => {
    if (currentTab === 'challenges') {
      Challenges.onAdd();
    }
  }, [currentTab]);

  const handleAddClick = React.useCallback(() => {
    switch (currentTab) {
      case 'habits':
        if (habitManagementRef.current) {
          habitManagementRef.current.handleAddClick();
        }
        break;
      case 'goals':
        if (typeof Goals.onAdd === 'function') {
          Goals.onAdd();
        }
        break;
      case 'challenges':
        if (typeof Challenges.onAdd === 'function') {
          Challenges.onAdd();
        }
        break;
      case 'notes':
        if (typeof Notes.onAdd === 'function') {
          Notes.onAdd();
        }
        break;
    }
  }, [currentTab]);

  const renderContent = React.useMemo(() => {
    const area = (activeArea === 'expansao' ? 'mentalidade' : activeArea);
    switch (currentTab) {
      case 'menu':
        return area === 'central' ? (
          <CentralDashboard
            habits={habits}
            goals={goals}
            challenges={challenges}
            events={events}
            customColors={customColors}
            onNavigate={handleTabChange}
            onAddHabit={onAddHabit}
            onDeleteHabit={onDeleteHabit}
            onReorderHabits={onReorderHabits}
            onDeleteAllHabits={onDeleteAllHabits}
            month={selectedMonth}
            year={selectedYear}
            onToggleHabit={onToggleHabit}
            onUpdateHabit={onUpdateHabit}
            showDailyQuote={showDailyQuote}
            onToggleDailyQuote={onToggleDailyQuote}
            componentsOrder={calendarComponentsOrder}
            onReorderComponents={setCalendarComponentsOrder}
            onMonthChange={handleMonthChange}
            onYearChange={handleYearChange}
            onUpdateCustomColors={onUpdateCustomColors}
            userId={userId}
            onEditHabitFromCalendar={(habit) => {
              if (habitManagementRef.current && typeof habitManagementRef.current.handleEditHabit === 'function') {
                habitManagementRef.current.handleEditHabit(habit);
              }
            }}
          />
        ) : (
          <PillarDashboard
            pillarId={area}
            habits={habits}
            goals={goals}
            challenges={challenges}
            events={events}
            customColors={customColors}
            onNavigate={handleTabChange}
          />
        );
      case 'calendar':
        return checkModuleEnabled('calendar') ? (
          <PageLayout
            title="Calendário"
            hideAddButton
            customColors={customColors}
          >
            <MonthCalendar
              habits={habits}
              month={selectedMonth}
              year={selectedYear}
              onToggleHabit={onToggleHabit}
              onUpdateHabit={onUpdateHabit}
              customColors={customColors}
              showDailyQuote={showDailyQuote}
              onToggleDailyQuote={onToggleDailyQuote}
              componentsOrder={calendarComponentsOrder}
              onReorderComponents={setCalendarComponentsOrder}
              onMonthChange={handleMonthChange}
              onYearChange={handleYearChange}
              onUpdateCustomColors={onUpdateCustomColors}
              onEditEvent={event => setEditEventDialog({ open: true, event })}
              events={events}
              setEvents={setEvents}
              onEditHabitFromCalendar={(habit) => {
                if (habitManagementRef.current && typeof habitManagementRef.current.handleEditHabit === 'function') {
                  habitManagementRef.current.handleEditHabit(habit);
                }
              }}
            />
            <Dialog open={editEventDialog.open} onClose={() => setEditEventDialog({ open: false, event: null })} maxWidth="sm" fullWidth>
              <DialogTitle>Editar Evento</DialogTitle>
              <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                  <TextField
                    label="Título"
                    fullWidth
                    value={editEventForm?.title || ''}
                    onChange={e => setEditEventForm(prev => ({ ...prev, title: e.target.value }))}
                    required
                    error={!editEventForm?.title}
                    helperText={!editEventForm?.title ? "Título é obrigatório" : ""}
                  />
                  <TextField
                    label="Descrição"
                    fullWidth
                    multiline
                    rows={4}
                    value={editEventForm?.description || ''}
                    onChange={e => setEditEventForm(prev => ({ ...prev, description: e.target.value }))}
                  />
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                    <DatePicker
                      label="Data"
                      value={editEventForm?.date || null}
                      onChange={date => setEditEventForm(prev => ({ ...prev, date }))}
                      renderInput={params => (
                        <TextField 
                          {...params} 
                          fullWidth 
                          required
                          error={!editEventForm?.date}
                          helperText={!editEventForm?.date ? "Data é obrigatória" : ""}
                        />
                      )}
                    />
                    <TimePicker
                      label="Horário (opcional)"
                      value={editEventForm?.time || null}
                      onChange={time => setEditEventForm(prev => ({ ...prev, time }))}
                      renderInput={params => <TextField {...params} fullWidth />}
                    />
                  </LocalizationProvider>
                  {editEventError && (
                    <Typography color="error" variant="body2">{editEventError}</Typography>
                  )}
                </Box>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setEditEventDialog({ open: false, event: null })}>Cancelar</Button>
                <Button 
                  onClick={handleEditEventSave}
                  variant="contained"
                  disabled={!editEventForm?.title || !editEventForm?.date}
                  color="primary"
                >
                  Salvar
                </Button>
              </DialogActions>
            </Dialog>
          </PageLayout>
        ) : <Navigate to="/menu" replace />;
      case 'habits':
        return (
          <PageLayout
            title="Hábitos"
            customColors={customColors}
            onAdd={handleAddClick}
            actionButtons={
              <Box sx={{ 
                display: 'flex', 
                gap: 1,
                width: { xs: '100%', sm: 'auto' },
                '& .MuiButton-root': {
                  flex: { xs: 1, sm: 'initial' },
                  minWidth: { xs: 0, sm: 'auto' },
                  px: { xs: 1.5, sm: 3 },
                  whiteSpace: 'nowrap',
                  fontSize: { xs: '0.75rem', sm: '1rem' }
                }
              }}>
                <Button
                  variant="outlined"
                  color="error"
                  startIcon={<DeleteIcon />}
                  onClick={() => {
                    setShowDeleteAllDialog(true);
                  }}
                >
                  Remover Todos
                </Button>
              </Box>
            }
          >
            {/* Calendário completo para realizar hábitos diretamente na aba Hábitos */}
            <Box sx={{ mb: 4 }}>
              <MonthCalendar
                habits={habits}
                month={selectedMonth}
                year={selectedYear}
                onToggleHabit={onToggleHabit}
                onUpdateHabit={onUpdateHabit}
                customColors={customColors}
                showDailyQuote={showDailyQuote}
                onToggleDailyQuote={onToggleDailyQuote}
                componentsOrder={calendarComponentsOrder}
                onReorderComponents={setCalendarComponentsOrder}
                onMonthChange={handleMonthChange}
                onYearChange={handleYearChange}
                onUpdateCustomColors={onUpdateCustomColors}
                // Na aba Hábitos, não tratamos edição de eventos pelo calendário
                onEditEvent={() => {}}
                events={events}
                setEvents={() => {}}
                onEditHabitFromCalendar={(habit) => {
                  if (habitManagementRef.current && typeof habitManagementRef.current.handleEditHabit === 'function') {
                    habitManagementRef.current.handleEditHabit(habit);
                  }
                }}
              />
            </Box>

            {/* Gestão de hábitos (lista, estatísticas, cadastro/edição) abaixo do calendário */}
            <HabitManagement
              ref={habitManagementRef}
              habits={habits}
              onDeleteHabit={onDeleteHabit}
              onUpdateHabit={onUpdateHabit}
              onReorderHabits={onReorderHabits}
              onAddHabit={onAddHabit}
              onDeleteAllHabits={onDeleteAllHabits}
              customColors={customColors}
            />
          </PageLayout>
        );
      case 'goals':
        return (
          <Goals
            habits={habits}
            customColors={customColors}
            onAdd={handleOpenDialog}
            hideAddButtonInHeader
          />
        );
      case 'challenges':
        return (
          <Challenges
            customColors={customColors}
            userId={userId}
            onAdd={handleOpen}
            hideAddButtonInHeader
          />
        );
      case 'pomodoro':
        return checkModuleEnabled('pomodoro') ? (
          <Pomodoro customColors={customColors} />
        ) : <Navigate to="/menu" replace />;
      case 'player':
        return checkModuleEnabled('player') ? (
          <Player customColors={customColors} />
        ) : <Navigate to="/menu" replace />;
      case 'statistics':
        return (
          <PageLayout
            title="Estatísticas"
            hideAddButton
            customColors={customColors}
          >
            <Statistics
              habits={habits}
              goals={goals}
              challenges={challenges}
              customColors={customColors}
            />
          </PageLayout>
        );
      case 'notes':
        return (
          <Notes
            customColors={customColors}
            onAdd={handleOpenDialog}
            hideAddButtonInHeader
          />
        );
      case 'events':
        return (
          <Events
            customColors={customColors}
            hideAddButtonInHeader
          />
        );
        
      case 'settings':
        return (
          <Settings
            customColors={customColors}
            onUpdateCustomColors={onUpdateCustomColors}
            showDailyQuote={showDailyQuote}
            onToggleDailyQuote={onToggleDailyQuote}
            mode={mode}
            onToggleMode={onToggleMode}
          />
        );
      case 'help':
        return (
          <Help
            customColors={customColors}
          />
        );
      case 'userManagement':
        return isAdmin ? (
          <UserManagement />
        ) : null;
      case 'sleep':
        return (
          <Sleep customColors={customColors} />
        );
      case 'treinos':
        return (
          <Treinos customColors={customColors} />
        );
      case 'estudos':
        return (
          <Estudos customColors={customColors} />
        );
      case 'nutricao':
        return (
          <Nutricao customColors={customColors} />
        );
      case 'meditations':
        return checkModuleEnabled('meditations') ? (
          <Meditations customColors={customColors} />
        ) : <Navigate to="/menu" replace />;
      case 'livros':
        return (
          <PageLayout
            title="Livros Recomendados"
            customColors={customColors}
          >
            <BookRecommendations />
          </PageLayout>
        );
      case 'bookRecommendations':
        return (
          <PageLayout
            title="Dicas de Livros"
            customColors={customColors}
          >
            <BookRecommendations />
          </PageLayout>
        );
      case 'orcamento':
        return <ProsperityBudget customColors={customColors} />;
      case 'investimentos':
        return <ProsperityInvestments customColors={customColors} />;
      case 'simulador':
        return <ProsperitySimulator customColors={customColors} />;
      default:
        return null;
    }
  }, [currentTab, activeArea, habits, goals, challenges, customColors, showDailyQuote, onToggleDailyQuote, mode, onToggleMode, onUpdateCustomColors, selectedMonth, selectedYear, calendarComponentsOrder, onToggleHabit, onUpdateHabit, onAddHabit, onDeleteHabit, onReorderHabits, onDeleteAllHabits, userId, isAdmin, events, editEventDialog, editEventForm, editEventError, handleEditEventSave, checkModuleEnabled, handleTabChange, handleAddClick, handleOpenDialog, handleOpen, habitManagementRef, setCalendarComponentsOrder, setEditEventDialog, setEditEventForm, setShowDeleteAllDialog]);

  const handleDeleteClick = (habit) => {
    setHabitToDelete(habit);
    setShowDeleteDialog(true);
  };

  const handleDeleteConfirm = () => {
    onDeleteHabit(habitToDelete);
    setShowDeleteDialog(false);
  };

  const handleDeleteAllClick = () => {
    setShowDeleteAllDialog(true);
  };

  const handleDeleteAllConfirm = () => {
    onDeleteAllHabits();
    setShowDeleteAllDialog(false);
  };

  const handleBackClick = () => {
    setCurrentTab('menu');
  };

  const handleDeleteAllGoals = () => {
    setShowDeleteAllGoalsDialog(true);
  };

  const handleDeleteAllGoalsConfirm = async () => {
    try {
      const userRef = doc(db, 'users', userId);
      await updateDoc(userRef, { goals: [] });
      setShowDeleteAllGoalsDialog(false);
    } catch (error) {
      console.error('Erro ao excluir todas as metas:', error);
    }
  };

  const handleDeleteAllChallenges = () => {
    setShowDeleteAllChallengesDialog(true);
  };

  const handleDeleteAllChallengesConfirm = async () => {
    try {
      const userRef = doc(db, 'users', userId);
      await updateDoc(userRef, { challenges: [] });
      setShowDeleteAllChallengesDialog(false);
    } catch (error) {
      console.error('Erro ao excluir todos os desafios:', error);
    }
  };

  const handleDeleteAllNotes = () => {
    setShowDeleteAllNotesDialog(true);
  };

  const handleDeleteAllNotesConfirm = async () => {
    try {
      const userRef = doc(db, 'users', userId);
      await updateDoc(userRef, { notes: [] });
      setShowDeleteAllNotesDialog(false);
    } catch (error) {
      console.error('Erro ao excluir todas as notas:', error);
    }
  };

  const handleHighlightTodayToggle = () => {
    // Implementation of handleHighlightTodayToggle
  };

  const handleHighlightPerfectDayToggle = () => {
    // Implementation of handleHighlightPerfectDayToggle
  };

  const handleShowDailyQuoteToggle = () => {
    // Implementation of handleShowDailyQuoteToggle
  };

  const handleShowProgrammedDaysToggle = () => {
    // Implementation of handleShowProgrammedDaysToggle
  };

  const handleModeChange = () => {
    onToggleMode();
  };


  const handleDrawerToggle = () => {
    setIsTransitioning(true);
    const newState = !drawerOpen;
    setDrawerOpen(newState);
    // Desativa transições após a animação
    setTimeout(() => {
      setIsTransitioning(false);
    }, theme.transitions.duration.standard * 1.5 + 50);
  };

  const handleDrawerClose = () => {
    setIsTransitioning(true);
    setDrawerOpen(false);
    // Desativa transições após a animação
    setTimeout(() => {
      setIsTransitioning(false);
    }, theme.transitions.duration.standard * 1.5 + 50);
  };

  // Menu lateral (Drawer) - estrutura base memoizada (sem currentTab)
  const drawerBase = React.useMemo(() => (
    <>
      <Toolbar
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: [2],
          bgcolor: customColors?.primary || 'primary.main',
          color: customColors?.primary ? getContrastText(customColors.primary) : theme.palette.primary.contrastText,
          minHeight: { xs: 56, sm: 64 },
          flexShrink: 0,
          zIndex: 1,
          position: 'relative'
        }}
      >
        <Typography variant="h6" noWrap component="div" sx={{ fontWeight: 'bold' }}>
          Menu
        </Typography>
        <IconButton
          onClick={handleDrawerClose}
          sx={{
            color: customColors?.primary ? getContrastText(customColors.primary) : theme.palette.primary.contrastText
          }}
        >
          {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </Toolbar>
      <Divider sx={{ flexShrink: 0 }} />
    </>
  ), [customColors, theme, handleDrawerClose]);

  // Lista de itens do menu - memoizada separadamente (estrutura: MENU > CENTRAL | VITALIDADE | EXPANSÃO | MENTALIDADE | PROSPERIDADE)
  const menuItemsList = React.useMemo(() => {
    const itemsMap = menuItems.reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});

    return (
      <Box sx={{ 
        flex: 1, 
        overflowY: 'auto', 
        overflowX: 'hidden',
        position: 'relative',
        willChange: 'auto',
        minHeight: 0
      }}>
        <List sx={{ pt: 2, pb: 0 }}>
          <ListItem disablePadding>
            <Box sx={{ 
              px: 2.5, 
              py: 0.75, 
              width: '100%',
              display: 'flex',
              alignItems: 'center'
            }}>
              <Typography
                variant="caption"
                sx={{
                  fontSize: '0.7rem',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  color: 'text.secondary',
                  opacity: 0.7
                }}
              >
                Menu
              </Typography>
            </Box>
          </ListItem>

          {MENU_SECTIONS.map((section) => {
            const isAreaActive = activeArea === section.id && currentTab === 'menu';
            const hasItems = section.items && section.items.length > 0;
            const effectiveSectionColor = section.id === 'central'
              ? (customColors?.primary || theme.palette.primary.main)
              : (customColors?.pillars?.[section.id] || section.color);

            return (
              <React.Fragment key={section.id}>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setActiveArea(section.id);
                      handleTabChange('menu');
                    }}
                    selected={isAreaActive}
                    sx={{
                      minHeight: 40,
                      px: 2.5,
                      '&.Mui-selected': {
                        bgcolor: alpha(effectiveSectionColor, 0.08),
                        borderLeft: `4px solid ${effectiveSectionColor}`,
                        '&:hover': { bgcolor: alpha(effectiveSectionColor, 0.12) }
                      },
                      '&:hover': { bgcolor: alpha(effectiveSectionColor, 0.04) }
                    }}
                  >
                    <ListItemIcon sx={{ color: effectiveSectionColor, minWidth: 36 }}>
                      {React.isValidElement(section.icon) && section.icon.type != null
                        ? React.cloneElement(section.icon, { sx: { fontSize: '1.2rem' } })
                        : null}
                    </ListItemIcon>
                    <ListItemText
                      primary={section.label}
                      primaryTypographyProps={{
                        fontWeight: isAreaActive ? 600 : 400,
                        fontSize: '0.875rem',
                        color: isAreaActive ? effectiveSectionColor : 'text.primary'
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                {hasItems && (
                  <List component="div" disablePadding dense>
                    {section.items.map((sub) => {
                        const subItem = itemsMap[sub.id];
                        if (!subItem || !subItem.icon) return null;
                        const isSelected = currentTab === sub.id;
                        return (
                          <ListItem key={sub.id} disablePadding sx={{ pl: 3 }}>
                            <ListItemButton
                              onClick={(e) => {
                                e.stopPropagation();
                                handleTabChange(sub.id);
                              }}
                              selected={isSelected}
                              sx={{
                                minHeight: 36,
                                '&.Mui-selected': {
                                  bgcolor: alpha(effectiveSectionColor, 0.1),
                                  borderLeft: `3px solid ${effectiveSectionColor}`,
                                  '&:hover': { bgcolor: alpha(effectiveSectionColor, 0.15) }
                                },
                                '&:hover': { bgcolor: alpha(effectiveSectionColor, 0.06) }
                              }}
                            >
                              <ListItemIcon sx={{ color: effectiveSectionColor, minWidth: 32 }}>
                                {React.isValidElement(subItem.icon) && subItem.icon.type != null
                                  ? React.cloneElement(subItem.icon, { sx: { fontSize: '1.1rem' } })
                                  : null}
                              </ListItemIcon>
                              <ListItemText
                                primary={sub.label}
                                primaryTypographyProps={{
                                  fontSize: '0.8125rem',
                                  fontWeight: isSelected ? 600 : 400,
                                  color: isSelected ? effectiveSectionColor : undefined
                                }}
                              />
                            </ListItemButton>
                          </ListItem>
                        );
                      })}
                    </List>
                )}
              </React.Fragment>
            );
          })}
        </List>
      </Box>
    );
  }, [currentTab, activeArea, customColors, theme, handleTabChange]);

  // Footer do drawer - memoizado
  const drawerFooter = React.useMemo(() => (
    <>
      <Divider sx={{ flexShrink: 0 }} />
      <Box sx={{ 
        px: 2, 
        py: 2,
        flexShrink: 0,
        // Previne movimento durante mudanças de conteúdo
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1
      }}>
        <Tooltip title={mode === 'dark' ? 'Modo Claro' : 'Modo Escuro'} arrow>
          <IconButton
            onClick={handleModeChange}
            sx={{
              color: 'text.primary',
              '&:hover': {
                bgcolor: alpha(customColors?.primary || theme.palette.primary.main, 0.1),
              }
            }}
          >
            {mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
          </IconButton>
        </Tooltip>
        <Tooltip title="Configurações" arrow>
          <IconButton
            onClick={() => handleTabChange('settings')}
            sx={{
              color: currentTab === 'settings' 
                ? (customColors?.primary || theme.palette.primary.main)
                : 'text.primary',
              '&:hover': {
                bgcolor: alpha(customColors?.primary || theme.palette.primary.main, 0.1),
              }
            }}
          >
            <SettingsIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Ajuda" arrow>
          <IconButton
            onClick={() => handleTabChange('help')}
            sx={{
              color: currentTab === 'help' 
                ? (customColors?.primary || theme.palette.primary.main)
                : 'text.primary',
              '&:hover': {
                bgcolor: alpha(customColors?.primary || theme.palette.primary.main, 0.1),
              }
            }}
          >
            <HelpIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Sair" arrow>
          <IconButton
            onClick={handleLogout}
            sx={{
              color: 'text.primary',
              '&:hover': {
                bgcolor: alpha(theme.palette.error.main, 0.1),
                color: theme.palette.error.main,
              }
            }}
          >
            <LogoutIcon />
          </IconButton>
        </Tooltip>
        {isAdmin && (
          <>
            <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
            <Tooltip title="Gerenciar Usuários" arrow>
              <IconButton
                onClick={() => {
                  handleTabChange('userManagement');
                }}
                sx={{
                  color: currentTab === 'userManagement'
                    ? (customColors?.primary || theme.palette.primary.main)
                    : 'text.primary',
                  '&:hover': {
                    bgcolor: alpha(customColors?.primary || theme.palette.primary.main, 0.1),
                  }
                }}
              >
                <GroupIcon />
              </IconButton>
            </Tooltip>
          </>
        )}
      </Box>
    </>
  ), [currentTab, isAdmin, customColors, theme, mode, handleTabChange, handleModeChange, handleLogout]);

  // Drawer completo - combina as partes
  // Usando React.memo implícito através da estrutura estável
  const drawer = React.useMemo(() => (
    <Box sx={{
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    }}>
      {drawerBase}
      {menuItemsList}
      {drawerFooter}
    </Box>
  ), [drawerBase, menuItemsList, drawerFooter]);

  return (
    <Box sx={{ 
      display: 'flex', 
      minHeight: '100vh', 
      height: '100vh', 
      overflow: 'hidden',
      // Garante que mudanças no conteúdo não afetem o drawer
      position: 'relative'
    }}>
      <Box
        position="fixed"
        sx={{
          top: 0,
          left: { xs: 0, sm: drawerOpen ? `${drawerWidth}px` : 0 },
          right: 0,
          zIndex: (theme) => theme.zIndex.drawer + 1,
          width: { 
            xs: '100%',
            sm: drawerOpen ? `calc(100% - ${drawerWidth}px)` : '100%'
          },
          height: { xs: 56, sm: 64 },
          display: 'flex',
          alignItems: 'center',
          px: 2,
          bgcolor: 'transparent',
          transition: isTransitioning 
            ? theme.transitions.create(['width', 'left'], {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.standard * 1.5,
              })
            : 'none',
        }}
      >
        {!drawerOpen && (
          <IconButton
            aria-label="abrir menu"
            onClick={handleDrawerToggle}
            sx={{
              mr: 2,
              color: 'text.primary'
            }}
          >
            <MenuIcon />
          </IconButton>
        )}
        
       
      </Box>
      <Box
        component="nav"
        sx={{ 
          width: { sm: drawerOpen ? drawerWidth : 0 },
          flexShrink: { sm: 0 },
          position: 'relative',
          zIndex: 1200,
          transition: isTransitioning 
            ? theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
              })
            : 'none',
          willChange: isTransitioning ? 'width' : 'auto',
        }}
        aria-label="menu de navegação"
      >
        {/* Drawer móvel */}
        <Drawer
          variant="temporary"
          open={drawerOpen}
          onClose={handleDrawerToggle}
          transitionDuration={isTransitioning ? theme.transitions.duration.standard * 1.5 : 0}
          ModalProps={{
            keepMounted: true, // Melhor performance em mobile
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              transition: isTransitioning 
                ? theme.transitions.create('transform', {
                    easing: theme.transitions.easing.easeInOut,
                    duration: theme.transitions.duration.standard * 1.5,
                  })
                : 'none',
            },
          }}
        >
          {drawer}
        </Drawer>
        {/* Drawer desktop */}
        <Drawer
          variant="persistent"
          open={drawerOpen}
          transitionDuration={isTransitioning ? theme.transitions.duration.standard * 1.5 : 0}
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              position: 'fixed',
              height: '100vh',
              top: 0,
              left: 0,
              zIndex: 1200,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              transition: isTransitioning 
                ? theme.transitions.create('width', {
                    easing: theme.transitions.easing.easeInOut,
                    duration: theme.transitions.duration.standard * 1.5,
                  })
                : 'none',
              willChange: isTransitioning ? 'width' : 'auto',
              backfaceVisibility: 'hidden',
              transform: 'translateZ(0)',
              WebkitTransform: 'translateZ(0)',
              // Garante que o drawer não seja afetado por mudanças no conteúdo
              isolation: 'isolate',
              // Força o drawer a ter seu próprio contexto de renderização
              contain: 'layout style paint',
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { 
            xs: '100%',
            sm: drawerOpen ? `calc(100% - ${drawerWidth}px)` : '100%'
          },
          height: '100vh',
          pt: { xs: 2, sm: 2 },
          pb: ((currentTab === 'menu' && activeArea === 'central') || ['habits', 'goals', 'challenges', 'events', 'notes'].includes(currentTab)) ? 0 : 3,
          bgcolor: theme.palette.background.default,
          transition: isTransitioning 
            ? theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.standard * 1.5,
              })
            : 'none',
          position: 'relative',
          overflowY: 'auto',
          overflowX: 'hidden',
          willChange: isTransitioning ? 'width, margin' : 'auto',
          isolation: 'isolate',
        }}
      >
        <Box 
          sx={{ 
            width: '100%', 
            minHeight: '100%', 
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            isolation: 'isolate',
            contain: 'layout style',
          }}
        >
          {children || renderContent}

          {/* Barra sticky de ações - grudada no rodapé da tela */}
          {((currentTab === 'menu' && activeArea === 'central') || ['habits', 'goals', 'challenges', 'events', 'notes'].includes(currentTab)) && (
            <Box
              sx={{
                position: 'sticky',
                bottom: 0,
                zIndex: (theme) => theme.zIndex.appBar + 1,
                pt: 2.55,
                pb: 2.55,
                mt: 'auto',
                backgroundColor: 'background.default',
                borderTop: (t) => `1px solid ${t.palette.divider}`,
                mx: { xs: -0.5, sm: -3 },
                px: { xs: 0.5, sm: 3 },
              }}
            >
              
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, justifyContent: 'center' }}>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => {
                    if (habitManagementRef.current && typeof habitManagementRef.current.handleAddClick === 'function') {
                      habitManagementRef.current.handleAddClick();
                    }
                  }}
                  sx={{
                    bgcolor: customColors?.primary || 'primary.main',
                    color: theme.palette.mode === 'dark' ? theme.palette.primary.contrastText : (getContrastText(customColors?.primary || theme.palette.primary.main) || theme.palette.primary.contrastText),
                    border: '1px solid',
                    borderColor: customColors?.primary || 'primary.main',
                    '&:hover': { opacity: 0.9 }
                  }}
                >
                  Novo Hábito
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => (typeof Goals.onAdd === 'function' ? Goals.onAdd() : handleTabChange('goals'))}
                >
                  Nova Meta
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => (typeof Challenges.onAdd === 'function' ? Challenges.onAdd() : handleTabChange('challenges'))}
                >
                  Novo Desafio
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => (typeof Events.onAdd === 'function' ? Events.onAdd() : handleTabChange('events'))}
                >
                  Novo Evento
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => (typeof Notes.onAdd === 'function' ? Notes.onAdd() : handleTabChange('notes'))}
                >
                  Nova Anotação
                </Button>
              </Box>
            </Box>
          )}

          {/* HabitManagement oculto para "Novo Hábito" quando não estamos na aba Hábitos (ref compartilhado) */}
          {(currentTab === 'menu' && activeArea === 'central') || ['goals', 'challenges', 'events', 'notes'].includes(currentTab) ? (
            <Box sx={{ display: 'none' }} aria-hidden="true">
              <HabitManagement
                ref={habitManagementRef}
                habits={habits}
                onDeleteHabit={onDeleteHabit}
                onUpdateHabit={onUpdateHabit}
                onReorderHabits={onReorderHabits}
                onAddHabit={onAddHabit}
                onDeleteAllHabits={onDeleteAllHabits}
                customColors={customColors}
              />
            </Box>
          ) : null}
        </Box>
      </Box>

      {/* Diálogo de confirmação para remover todos os hábitos */}
      <Dialog
        open={showDeleteAllDialog}
        onClose={() => setShowDeleteAllDialog(false)}
        aria-labelledby="delete-all-dialog-title"
        aria-describedby="delete-all-dialog-description"
      >
        <DialogTitle id="delete-all-dialog-title">Confirmar exclusão</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-all-dialog-description">
            Tem certeza que deseja excluir todos os hábitos? Esta ação não pode ser desfeita.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowDeleteAllDialog(false)}>Cancelar</Button>
          <Button 
            onClick={() => {
              onDeleteAllHabits();
              setShowDeleteAllDialog(false);
            }} 
            color="error" 
            variant="contained"
          >
            Excluir Todos
          </Button>
        </DialogActions>
      </Dialog>


      <Snackbar open={successSnackbar} autoHideDuration={3000} onClose={() => setSuccessSnackbar(false)} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <MuiAlert onClose={() => setSuccessSnackbar(false)} severity="success" elevation={6} variant="filled">
          Alteração efetuada com sucesso
        </MuiAlert>
      </Snackbar>
    </Box>
  );
}

export default Navigation; 